<script>
import modelBypassMixin from '#/vue/vue-src/utils/model-bypass-mixin'
import checkoutMixin from '@/v-shop/checkout/checkout-mixin'
import moment from 'moment'

export default {
	lang: 'shop',
	mixins: [modelBypassMixin(String, null), checkoutMixin],
	props: {
		selector: Object,
	},
	data() {
		return {
			btnStatus: 'default',
			redirecting: false,
			loading: false,
			paymentData: null,
			embedFormError: false,
			showToast: false,
		}
	},
	computed: {
		embedFormInCheckout() {
			return this.checkout?.stepViewData?.embedFormInCheckout
		},
	},
	methods: {
		async submit() {
			if ((await this.checkout.beforeConfirm()) === false) return
			this.btnStatus = 'loading'
			const response = await this.checkout.stepSubmit()
			const initPoint = response?.data?.stepResponse?.initPoint
			if (initPoint) {
				window.location.href = initPoint
				this.redirecting = true
			} else {
				this.btnStatus = 'error'
			}
		},
		async copyToClipboard(text) {
			await navigator.clipboard.writeText(text)
			this.showToast = true
			setTimeout(() => {
				this.showToast = false
			}, 3000)
		},
		moment,
	},
	async mounted() {
		if (this.embedFormInCheckout) {
			if ((await this.checkout.beforeConfirm()) === false) return
			const response = await this.checkout.stepSubmit()
			const paymentData = response?.data?.stepResponse?.paymentData
			if (paymentData) {
				this.paymentData = paymentData
			} else {
				this.embedFormError = true
			}
		}
	},
}
</script>
<template>
	<div v-if="embedFormError">
		<div
			class="font-2 error--text text-center"
			v-html="$lang('Ha ocurrido un error al cargar el formulario de pago.')"
		></div>
	</div>
	<div v-else-if="embedFormInCheckout">
		<div>
			<TaloTransferInfo
				v-if="paymentData"
				:payment-data="paymentData"
				:order-id="this.checkout.order.id"
				@payment-confirmed="$router.replace(`/user/orders/${checkout.order.id}`)"
			/>
			<div v-else>
				<div class="d-flex justify-center">
					<v-progress-circular indeterminate color="primary"></v-progress-circular>
				</div>
			</div>
		</div>
	</div>
	<div v-else>
		<div>
			<b> Serás redirigido a la plataforma de Talo para finalizar tu compra. </b>
		</div>
		<div class="d-flex justify-center justify-sm-end pt-6">
			<IndeterminateProgressBtn
				v-model="btnStatus"
				default-color="cta"
				success-color="success"
				error-color="error"
				@click="submit()"
				:error-duration="5000"
				block
				x-large
			>
				Realizar Pago
				<template #loading>
					{{ redirecting ? 'Redirigiendo a Talo...' : 'Generando Link de Pago...' }}
				</template>
				<template #success>
					<div></div>
				</template>
				<template #error>
					<v-icon left> mdi-close-thick </v-icon>
					Lo sentimos, ha ocurrido un error
				</template>
			</IndeterminateProgressBtn>
		</div>
	</div>
</template>

<style scoped lang="scss">
.talo-box {
	border: 1px solid #ccc;
	padding: 12px;
	margin: 16px 0;
	display: flex;
	flex-direction: column;
	gap: 8px;
	border: 1px solid #ccc;
	border-radius: 4px;

	&--interactive {
		cursor: pointer;

		&:hover {
			transform: scale(1.01);
			transition: transform 0.2s;
		}
	}
}

.toast {
	position: fixed;
	bottom: 16px;
	right: 16px;
	background-color: var(--success);
	color: var(--successtext);
	padding: 8px 16px;
	border-radius: 4px;
	opacity: 0.9;
}

.toast-slide-enter-active,
.toast-slide-leave-active {
	transition: all 0.3s ease;
}

.toast-slide-enter-from {
	transform: translateY(100%);
	opacity: 0;
}

.toast-slide-leave-to {
	transform: translateX(100%);
	opacity: 0;
}
</style>

